import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles(() => ({

  paperRounded: {
    borderRadius: 12,
  },

  dialogBoxInternal: {
    boxSizing: "border-box",
    fontFamily: "Roboto",
    maxWidth: 930,
    padding: "16px 32px 24px",
    background: colors.white,
  },

  closeBtn: {
    width: 18,
    height: 18,
    cursor: "pointer",
    justifySelf: "end"
  },

  closeBtnIcon: {
    width: 18,
    height: 18,
    stroke: colors.darkBlue900,
  },

  headerContainer: {
    boxSizing: "border-box",
    display: "flex",
    // Top-aligned per Figma: the back and close controls (18px) sit at the
    // top edge of the header, next to the top of the 40px logo.
    alignItems: "flex-start",
    height: 72,
    background: colors.lightGradient,
    borderRadius: 4,
    padding: 16,
    marginBottom: 10,
  },

  // Equal-width side zones keep the logo centered whether or not the
  // "Previous Options" button is rendered.
  headerSide: {
    display: "flex",
    flex: 1,
    alignItems: "center",
  },

  headerSideEnd: {
    justifyContent: "flex-end",
  },

  backBtn: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: 0,
    borderRadius: 4,
  },

  backBtnIcon: {
    width: 18,
    height: 18,
  },

  backBtnText: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 12,
    lineHeight: "16px",
    color: colors.darkBlue900,
  },

  codeJamItemLogo: {
    height: 40,
  },

  tabElementHeader: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "32px",
    marginBottom: 20,
  },
}));

export { useStyles };
